import '../styles/LoginStepRail.css';
import React from 'react';

const STEPS = [
  { no: '01', name: 'Entry', note: 'Public entry — product explained before sign-in' },
  { no: '02', name: 'Identity', note: 'Enroll a new identity or verify a returning one' },
  { no: '03', name: 'Extraction', note: 'Start a LinkedIn run and read the returned leads' },
  { no: '04', name: 'Leads', note: 'Review saved lead lists in a later session' },
];

const ACTIVE_STEP_NO = '02';

function LoginStepRail() {
  const activeIndex = STEPS.findIndex((step) => step.no === ACTIVE_STEP_NO);
  const activePosition = String(activeIndex + 1).padStart(2, '0');

  return (
    <section className="lsr-root" aria-label="Login progress">
      <div className="lsr-rail">
        <p className="lsr-kicker">
          <span className="lsr-kicker-dot" aria-hidden="true" />
          Steps
        </p>

        <ol className="lsr-list">
          {STEPS.map((step) => {
            const isActive = step.no === ACTIVE_STEP_NO;
            return (
              <li
                key={step.no}
                className="lsr-step"
                aria-current={isActive ? 'step' : undefined}
              >
                <span className="lsr-step-no">
                  <span className="lsr-marker" aria-hidden="true" />
                  <span>{step.no}</span>
                </span>
                <span className="lsr-step-name">{step.name}</span>
                <span className="lsr-visually-hidden">
                  {isActive ? 'Current step. ' : ''}
                  {step.note}
                </span>
              </li>
            );
          })}
        </ol>

        <p className="lsr-fineprint">
          <span>Step</span>
          <span className="lsr-fineprint-value">
            {activePosition} / {String(STEPS.length).padStart(2, '0')}
          </span>
        </p>
      </div>
    </section>
  );
}

export default LoginStepRail;